import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { billState, purchaseBillSlicer } from './billSlice';

// API
import  {
  
  iPurchaseBillResponse,
  sortDirectionType,
} from '../../../services/api/api';

// Components
import TableActionBar from '../../../components/TableActionBar/TableActionBar';

import {
  EllipsisLoader,
  WhiteboxLoader,
} from '../../../components/Loader/Loader';

import { Confirm } from '../../../components/Alerts/Alerts';
import { havePermission } from '../../../services/hoc/permissions';
import { Col, Row } from 'react-grid-system';

import { useLocation, useNavigate } from 'react-router-dom';
import { useNotification } from '../../../services/usenotification';
import { Tooltip } from '@mui/material';
import { IconButton } from '../../../components/icon-button';
import { Launch } from '@mui/icons-material';
import { getListSort } from '../../../services/hoc/sort';
import { SortTable } from '../../../components/Table/SortTable';
import { RowContainer } from '../../../components/Table/row_container';

import { useAPI } from '../../../services/hoc/useAPI';

const Bills= () => {
  // Translation
  const t = useTranslation();
  const location = useLocation();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
 const  keyword_ref =useRef<string|null>(null)
  const navigate = useNavigate();
  const { alert, alertError500 } = useNotification();
const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { purchaseBill: billState }) => state.purchaseBill,
  );



 const ENDPOINTS = useAPI()


  // Search
  // const search = (value: string) => {
  //   tableRef.current?.reset();
  //   dispatch(purchaseBillSlicer.actions.reset());
  //   setKeyword(value);
  // };
  const search = (value: string) => {
    dispatch(purchaseBillSlicer.actions.reset());
     keyword_ref.current = Boolean(value)?value:null
    fetchData(1,Boolean(value)? 20:8, value);
  };

  // Fetch Data
  const fetchData = useCallback((
    page: number,
    page_size: number = 10,
    keyword?: string,
    sort_direction?:sortDirectionType,
    sort_field?:number
  ) => {
    dispatch(purchaseBillSlicer.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.purchaseBill()
      .index({
        page,
        page_size,
        keyword,
        sort_direction,
        sort_field,
      })
      .then((response: any) => {
        dispatch(purchaseBillSlicer.actions.setIsFetching(false));
        dispatch(purchaseBillSlicer.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let bills: iPurchaseBillResponse[] =
          response.data.data.puchasebills.map(
            (bill: any): iPurchaseBillResponse => ({
              ...bill,
            }),
          );

        dispatch(purchaseBillSlicer.actions.init(bills));

        if (!state.isLoaded)
          dispatch(purchaseBillSlicer.actions.setIsLoaded(true));
        dispatch(purchaseBillSlicer.actions.setIsFetching(false));
      })
      .catch((err: any) => {
        dispatch(purchaseBillSlicer.actions.setIsFetching(false));
      });
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
      sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field
     
      //setSortOptions(pre=>({...pre,sort_direction,sort_field}))
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])

  // Fetch Services

 
  const goToPurcahseOrder = (order: iPurchaseBillResponse) => (
    <IconButton
      DoIcon={<Launch sx={{ color: 'var(--primary-color)' }} />}
      cancelTitle=""
      doTitle={t('show_order')}
      value={false}
      style={{ margin: '0 5px' }}
      doFunction={() => 
        {
          navigate(`/add-purchase-order/${order.purchase_order_id}`);
          return true;
        }
      }
    />
  );
  const actions = (order: iPurchaseBillResponse) => (
    <div className="show-on-hover">
      {havePermission('Show Purchase Bill') && (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              navigate(`/purchase-bills/${order.id}`);
            }}
          />
        </Tooltip>
      )}

      {havePermission('Delete Purchase Bill') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(order.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
  const rows = () => {
    return state.bills[state.page]
      ? state.bills[state.page]!.map((order, index) => {
          return (
            <RowContainer
              item_id={order.id?.toString() as string}
              onSelect={toggleSelectedId}
              state_length={state.bills[state.page]?.length as number}
              tr_index={index}
              columns={[
                order.bill_no,
                order.supplier ? order.supplier.name : '',
                order.date?.replaceAll('-','/'),
                order.type,
                goToPurcahseOrder(order),
                actions(order),
              ]}
            />
          );
        })
      : null;
  };

  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Purchase Bill')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(purchaseBillSlicer.actions.setIsLoading(true));
    ENDPOINTS.purchaseBill()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(purchaseBillSlicer.actions.setIsLoading(false));
        dispatch(purchaseBillSlicer.actions.deleteBill(ids));
        alert(
          { en: 'your deletion was succefull', ar: 'تم الحذف بنجاح' },
          'success',
        );
      })
      .catch((err: any) => {
        alertError500(err)
          dispatch(purchaseBillSlicer.actions.setIsLoading(false));
      }
      )
      
  };

  // Delete

  // First fetch
  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {
        search(location.state.key)
      }
    } else {
      if (!state.isLoaded && !state.isFetching) {
        fetchData(1);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        dispatch(purchaseBillSlicer.actions.setPage(pagesInfo.page));
        fetchData(pagesInfo.page,8,'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo]);

  return (
    <>
      {state.isLoaded ? (
        <>
       
          {state.isLoading ? <WhiteboxLoader /> : ''} 
          <Row>
            <Col md={12}>
              <div
                style={{
                  maxHeight: 'calc(100vh - 130px)',
                  overflow: 'hidden auto',
                }}>
                <TableActionBar
                  keyword={location.state ? location.state.key : ''}
                  title={t('purchase_bills')}
                  search={search}
                  showFilter={false}
                  showDelete={selectedIds.length > 0}
                  delete={() => {
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(),
                    });
                  }}
                  addText={t('add_to_materials')}
                />

                {/* <DashboardTable
                  
                  header={[
                    t('supplier'),
                    t('delivery_order_num'),
                    t('delivery_date'),
                    t('type'),
                    t('go_to_purchase_order'),
                    '',
                  ]}
                  body={generateData()}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => {}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  sort_fields={getListSort(['supplier'
                  ,'delivery_order_num','delivery_date','type','go_to_purchase_order'
                  ,''],'Purchase_Bill')}
                  fetchSortedData={fetchSortedData}
                /> */}
                <SortTable
                  header={[
                    t('bill_no'),
                    t('supplier'),
                    t('bill_date'),
                    t('type'),
                    t('go_to_purchase_order'),
                    '',
                  ]}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => {}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  sort_fields={getListSort(
                    [
                      'bill_no',
                      'name',
                      'date',
                      'type',
                      'go_to_purchase_order',
                      '',
                    ],
                    'Purchase_Bill',
                  )}
                  fetchSortedData={fetchSortedData}
                  state={state.bills[state.page] ?? []}>
                  <>{rows()}</>
                </SortTable>
              </div>
              <div></div>
            </Col>
          </Row>
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default Bills ;